<template>
  <div>
    <Price
      v-if="!isB2B && validInCurrentMarket"
      :product="product"
      :priceClass="priceClass"
      :priceExVatClass="priceExVatClass"
    />
    <B2B
      v-if="isB2B"
      :product="product"
      :priceClass="priceClass"
      :priceExVatClass="priceExVatClass"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import B2B from './b2b.vue';
import Price from './price.vue';

export default {
  props: {
    product: Object,
    validInCurrentMarket: Boolean
  },
  components: {
    B2B,
    Price
  },
  computed: {
    ...mapGetters(['isB2B']),
    priceClass() {
      return this.validInCurrentMarket
        ? "product-aside-price"
        : "product-aside-price product-aside-price--outofstock";
    },
    priceExVatClass() {
      return this.validInCurrentMarket
        ? "product-aside-price-exvat"
        : "product-aside-price-exvat product-aside-price-exvat--outofstock";
    }
  }
};
</script>
